import GenericDatePicker from '../generic-date-picker/GenericDatePicker';
import React from 'react';
import {useField} from 'formik';
import {endOfISOWeek, isSameISOWeek, startOfISOWeek} from 'date-fns';

function FormikWeekPicker({name, disabled, ...props}) {
    let [, fieldMeta, fieldHelpers] = useField(name);

    return (
        <GenericDatePicker
            name={name}
            selectsRange={true}
            showTimeSelect={false}
            showWeekNumbers={false}
            selected={fieldMeta.value ? new Date(+fieldMeta.value) : null}
            onChange={(v) => fieldHelpers.setValue(Date.parse(v))}
            dateFormat={'dd MMM yyyy'}
            dayClassName={(date) =>
                isSameISOWeek(date, new Date(+fieldMeta.value)) ? 'react-datepicker__day--selected' : ''
            }
            startDate={fieldMeta.value ? startOfISOWeek(new Date(+fieldMeta.value)) : null}
            endDate={fieldMeta.value ? endOfISOWeek(new Date(+fieldMeta.value)) : null}
            openToDate={undefined}
            weekPicker
            disabled={disabled}
            {...props}
        />
    );
}

export {FormikWeekPicker};
